/* eslint-disable import/prefer-default-export */

import { useMediaQuery } from 'react-responsive';

export function useTabletOrLarger() {
  return useMediaQuery({ minWidth: 767 });
}
